import moment from 'moment';
import { IconNames } from '@shipengine/giger-theme';
import { Icon, Typography } from '@shipengine/giger';
import { useTranslation } from '@packlink/translation-provider';
import { getRouteSectionStyles, getRouteTitleWrapperStyles, getRouteIconStyles, getRouteTimeStyles, getRouteCaptionStyles } from '../RouteStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const Delivery = _ref => {
  let {
    delivery: {
      date,
      dropOff
    }
  } = _ref;
  const {
    t
  } = useTranslation();
  const title = t(`service-card.delivery-type.${dropOff ? 'pick-up' : 'delivery'}`);
  const description = t(`service-card.delivery.${dropOff ? 'pick-up' : 'delivered'}`);
  return jsxs("section", {
    css: getRouteSectionStyles,
    children: [jsxs("div", {
      css: getRouteTitleWrapperStyles,
      children: [jsx(Icon, {
        css: getRouteIconStyles,
        name: dropOff ? IconNames.MARKER : IconNames.HOUSE
      }), jsx(Typography, {
        variant: "subtitle2",
        children: title
      })]
    }), jsx(Typography, {
      variant: "small",
      css: getRouteTimeStyles,
      children: jsx("time", {
        dateTime: moment(date).format(moment.HTML5_FMT.DATETIME_LOCAL),
        children: moment(date).format('ddd, MMMM DD')
      })
    }), jsx(Typography, {
      variant: "small",
      css: getRouteCaptionStyles,
      children: jsx("p", {
        children: description
      })
    })]
  });
};

export { Delivery };
//# sourceMappingURL=Delivery.js.map
